module.exports = __webpack_public_path__ + "img/oven-fried-green-tomatoes.d197bdd8.jpg";